import { useTranslation } from 'next-i18next';
import { DialogHeader } from '@/ui_v3';
export const BuildAiModalHeader = ({
  onClose
}: {
  onClose: () => void;
}) => {
  const {
    t
  } = useTranslation(['build']);
  return <DialogHeader className="!pt-md pb-xs" hasCloseButton={true} title={t('build:ai.header.title')} onClose={onClose} data-sentry-element="DialogHeader" data-sentry-component="BuildAiModalHeader" data-sentry-source-file="BuildAiModalHeader.tsx" />;
};